import { useWalletAddressUserData } from '@/hooks/useWalletAddressUserData';
import { Button, Flex, Heading, Icon, Image, Text, type FlexProps } from '@chakra-ui/react';
import { MdArrowOutward } from 'react-icons/md';
import { SmartLink } from './smart-link';

interface RestrictedWalletProps extends FlexProps {
  address: `0x${string}`;
}

export const RestrictedWallet = ({ address, ...props }: RestrictedWalletProps) => {
  const { stats } = useWalletAddressUserData(address);
  const isRestricted = stats?.xpRank === null;

  if (!isRestricted) return null;

  return (
    <Flex
      direction="column"
      align="center"
      textAlign="center"
      p={6}
      gap={4}
      py={{ base: 12, md: '72px' }}
      px={8}
      bgColor="white"
      bgImage="url('/assets/profile/blocks-bg.jpg')"
      bgSize="cover"
      my={6}
      borderColor="border"
      borderWidth={1}
      borderStyle="solid"
      borderRadius="2xl"
      {...props}
    >
      <Image boxSize={16} src="/assets/pp-square.svg" alt="" filter="grayscale(1)" />

      <Heading size="2xl" fontWeight="bold">
        Wallet Restricted from Plume Points
      </Heading>

      <Text fontSize="md" color="fg.muted" maxW="500px" fontWeight={500}>
        Your wallet isn't earning Plume Points for Season 2. If you think this is a mistake, we're happy to help. All
        points will be retroactively allocated if required.
      </Text>

      <SmartLink href="https://discord.com/invite/plume-network">
        <Button colorScheme="blue" size="md" mt={2} variant="outline" rounded="full">
          Chat on Discord
          <Icon as={MdArrowOutward} boxSize={4} />
        </Button>
      </SmartLink>
    </Flex>
  );
};
